<template>
  <div class="demo-signature">
    <div class="demo-popup" v-if="show">
    <!--<div class="demo-popup">-->
      <div>
        请签上你的大名
        <a @click="hidePopup">隐藏</a>
      </div>
      <div class="bx-signature"></div>
      <div>
        <a @click="createImage">点我预览</a>
        <a @click="clearCanvas">我要重置</a>
      </div>
      <div class="demo-signature-preview">
        <img v-if="base64" :src="base64"/>
      </div>
      <!--<div>Base64图片</div>-->
      <!--<div class="demo-signature-base64">-->
        <!--<textarea rows="5">{{base64}}</textarea>-->
      <!--</div>-->
      <!--<div>url图片</div>-->
      <!--<div class="demo-signature-base64">-->
        <!--<textarea rows="3">{{image}}</textarea>-->
      <!--</div>-->
    </div>
    <div class="demo-btn" v-if="!show" @click="showPopup">我要签名</div>
  </div>
</template>
<script>
  import Signature from '@packages/components/signature/signature';
  import Uploader from '@packages/components/uploader/uploader';
  import Utils from '@/utils/common.js';
  import Api from '@/utils/api.js';
  var FILEDIR = 'tinsurance_refund';
  export default {
    data () {
      return {
        show: false,
        base64: null,
        image: null,
        signature: null
      }
    },
    methods: {
      getSuffix: function (filename) {
        var pos = filename.lastIndexOf('.')
        var suffix = '';
        if (pos !== -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      createImage: function () {
        var self = this;
        self.base64 = self.signature.toImage();
        self.base64 && self.uploadBase64();
      },
      clearCanvas: function () {
        var self = this;
        self.signature.reset();
        self.image = null;
        self.base64 = null;
      },
      showPopup: function () {
        var self = this;
        self.show = true;
        self.$nextTick(function () {
          if (!self.signature) {
            // eslint-disable-next-line
            self.signature = new Signature('.bx-signature', {});
          }
        });
      },
      hidePopup: function () {
        var self = this;
        self.show = false;
      },
      uploadBase64: function () {
        var self = this;
        // eslint-disable-next-line
        var uploader = new Uploader(null, {
          url: window.location.origin + '/oss/upload',
          data: {
            success_action_status: 200
          },
          autoUpload: false,
          base64: self.base64,
          onBefore: function (file) {
            Api.getAuthInfo(FILEDIR).then(function (response) {
              var data = response.data.data;
              // 正式情况使用
              // uploader.options.url = data.host;
              uploader.options.data.signature = data.signature;
              uploader.options.data.policy = data.policy;
              uploader.options.data.OSSAccessKeyId = data.accessid;
              uploader.options.data.key = data.dir + data.fileName + '.png';
              uploader.upload();
            });
          },
          onSuccess: function () {
            self.image = 'http://media.winbaoxian.com/' + this.options.data.key;
          },
          onError: function (xhr, status, message) {
            console.log(xhr, status, message);
          }
        });
      }
    },
    created: function () {
      Utils.setCookie('adminToken', '2909498feecb4ef1a571b4ec4dda36f7');
    },
    mounted: function () {
    }
  }
</script>
<style scoped>
  .demo-signature {
  }

  .demo-popup {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 15px 15px;
    font-size: 14px;
  }

  .bx-signature {
    height: 150px;
    margin: 15px 0;
    border: 1px solid #CCC;
  }

  .demo-signature-preview {
    height: 150px;
    margin: 15px 0;
    border: 1px solid #CCC;
  }

  .demo-signature-preview img {
    width: 100%;
  }

  .demo-signature-base64 {
    margin: 15px 0;
    border: 1px solid #CCC;
  }

  .demo-signature-base64 textarea {
    width: 100%;
    border: 0;
  }

  .demo-btn {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    padding: 15px 0;
    color: #FFF;
    background: #b5d592;
  }
</style>



// WEBPACK FOOTER //
// src/views/Signature.vue